export const STORYLINE_TITLES = {
    1: 'Digital Change',
    2: 'AI BLUR',
};

export const DEFAULT_TITLE = 'Digital Change';

export default {
    STORYLINE_TITLES,
    DEFAULT_TITLE
};
